import Config from '../Config';
import Registry from '../Stores/Registry';

export default class Helper {

	/* Environment */

	static development() {
		const development = ['localhost', 'e2-zonscherm-master.test.flaire.nl'];
		return development.includes(window.location.hostname);
	}

	static environment() {
		return Helper.development() ? 'development' : 'production';
	}

	static mobile() {
		const query = window.matchMedia('only screen and (max-width: 1024px) and (orientation: portrait)');
		return !!query.matches;
	}

	/* Content */

	static image(path) {
		const local = /^[\.\/]/.test(path);
		let uri = local ? path : `/${Config.shop.resource}/${path}`;
		if (Helper.development())
			uri = `${Registry.shopDomain()}${uri}`;

		return uri;
	}

	static async hash(content) {
		const encoded = new TextEncoder().encode(content);
		const digest = await crypto.subtle.digest('SHA-256', encoded);
		const data = Array.from(new Uint8Array(digest));
		const hex = data.map(b => b.toString(16).padStart(2, '0')).join('');
		return hex;
	}

	static stop(event) {
		if (Helper.is(event)) {
			event.stopPropagation();
			event.preventDefault();
		}
	}

	/* Data */

	static type(content, type) {
		return typeof content === type;
	}

	static undefined(content) {
		return Helper.type(content, 'undefined');
	}

	static equals(content, check) {
		const equals = false;
		if (Array.isArray(content)) {
			const lower = content.map(item => item.toLowerCase());
			equals = lower.includes(check.toLowerCase());
		}
		else equals = content.toLowerCase() === check.toLowerCase();
		return equals;
	}

	static iterable(content) {
		return Helper.is(content) && (typeof content[Symbol.iterator] === 'function');
	}

	static is() {
		const empty = content => {
			let empty = true;
			for (const key in content) {
				empty = false;
				break;
			}

			return empty;
		};

		let is = false;
		for (const content of arguments) {
			switch (typeof content) {
				case 'boolean': is = content; break;
				case 'object': is = !empty(content); break;
				default: is = !!content; break;
			}

			if (!is) break;
		}

		return is;
	}
}
